import { render, staticRenderFns } from "./ProductTop.vue?vue&type=template&id=1dc9ed79&scoped=true"
import script from "./ProductTop.vue?vue&type=script&lang=js"
export * from "./ProductTop.vue?vue&type=script&lang=js"
import style0 from "./ProductTop.vue?vue&type=style&index=0&id=1dc9ed79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc9ed79",
  null
  
)

export default component.exports